<template>
    <div class="partner">
        <div class="header_btn" @keyup.enter="searchBtn">
            <el-select v-model="exportType" class="force-style-input" placeholder="请选择导出类型" size="large" clearable
                style="width: 220px;margin-right: 10px;">
                <el-option label="订单导出" :value="1" />
                <el-option label="商品明细导出" :value="2" />
            </el-select>
            <el-select v-model="state" class="force-style-input" placeholder="请选择任务状态" size="large" clearable
                style="width: 220px;margin-right: 10px;">
                <el-option v-for="item in taskStateOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-button size="large" style="margin:0 0 10px 0;" @click="resetBtn">重置</el-button>
            <el-button type="primary" size="large" style="margin:0 0 10px 10px;" :loading="loading" @click="searchBtn">
                <el-icon class="cancelgu"><Search /></el-icon>搜索
            </el-button>
        </div>

        <div class="summation">
            <div class="hint">统计 : {{ total }}条</div>
            <div class="hint">提示 : 任务有效天数为7天。</div>
        </div>

        <el-table v-loading="loading" class="manage-list-table" :data="tableData" border style="width: 100%"
            :header-cell-style="{ background: '#F5F7FA' }" empty-text="暂无数据">
            <el-table-column label="任务编号" prop="taskNo" min-width="360" align="center" show-overflow-tooltip />
            <el-table-column label="导出类型" prop="exportType" width="180" align="center">
                <template #default="{ row }">
                    <el-tag v-if="Number(row.exportType) === 1">订单导出</el-tag>
                    <el-tag v-else-if="Number(row.exportType) === 2" type="success">商品明细导出</el-tag>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="任务状态" prop="state" width="180" align="center">
                <template #default="{ row }">
                    <el-tag v-if="getTaskState(row.state)" :type="getTaskState(row.state).type">
                        <el-icon v-if="isTaskPending(row.state)" class="is-loading task-loading-icon"><Loading /></el-icon>
                        {{ getTaskState(row.state).label }}
                    </el-tag>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="预计总数量" prop="totalCount" width="150" align="center" :formatter="formatEmptyValue" />
            <el-table-column label="已处理数量" prop="processedCount" width="150" align="center" :formatter="formatEmptyValue" />
            <el-table-column label="创建时间" prop="createTime" width="200" align="center" :formatter="formatTime" />
            <el-table-column label="开始时间" prop="startTime" width="200" align="center" :formatter="formatTime" />
            <el-table-column label="完成时间" prop="finishTime" width="200" align="center" :formatter="formatTime" />
            <el-table-column label="过期时间" prop="expireTime" width="200" align="center" :formatter="formatTime" />
            <el-table-column label="操作人" prop="createdName" width="160" align="center" show-overflow-tooltip :formatter="formatEmptyValue" />
            <el-table-column label="失败原因" prop="failReason" min-width="180" align="center" show-overflow-tooltip :formatter="formatEmptyValue" />
            <el-table-column label="文件名称" prop="fileName" min-width="200" align="center" show-overflow-tooltip :formatter="formatEmptyValue" />
            <el-table-column fixed="right" label="下载地址" width="160" align="center">
                <template #default="{ row }">
                    <el-button v-if="canDownload(row)" size="default" class="bulur"
                        @click="downloadFile(row)"><el-icon class="cancel"><Download /></el-icon>下载</el-button>
                    <span v-else>-</span>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination :hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[6, 10, 15, 20]"
            :current-page="currentPage" :page-size="pageSize" :total="total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
    </div>
</template>

<script>
export default {
    name: 'orderExportList'
}
</script>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import moment from 'moment';
import { ElMessage } from 'element-plus';
import { Download, Loading, Search } from '@element-plus/icons-vue';
import { queryExportTaskList } from '../../../request/api';
import { isRequestErrorHandled } from '../../../request/authExpired';

const exportType = ref('');
const state = ref('');
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const loading = ref(false);
const tableData = ref([]);
const currentTime = ref(Date.now());
const taskValidityMs = 7 * 24 * 60 * 60 * 1000;
let expirationTimer;
let pollingTimer;
let requestVersion = 0;
let disposed = false;
let appliedQueryParams;

const taskStateOptions = [
    { value: 0, label: '待执行', type: 'info' },
    { value: 1, label: '生成中', type: 'warning' },
    { value: 2, label: '已完成', type: 'success' },
    { value: 3, label: '生成失败', type: 'danger' },
    { value: 4, label: '已取消', type: 'info' },
    { value: 5, label: '已过期', type: 'info' }
];

const isEmptyValue = (value) => value === null || value === undefined || value === '';

const canDownload = (row) => {
    if (!row.fileUrl || Number(row.state) === 5 || isEmptyValue(row.startTime)) return false;
    const startTime = Number(row.startTime);
    return Number.isFinite(startTime) && currentTime.value < startTime + taskValidityMs;
};

const formatEmptyValue = (row, column, cellValue) => isEmptyValue(cellValue) ? '-' : cellValue;

const formatTime = (row, column, cellValue) => {
    if (isEmptyValue(cellValue)) return '-';
    return moment(Number(cellValue)).format('YYYY-MM-DD HH:mm:ss');
};

const getTaskState = (value) => taskStateOptions.find((item) => item.value === Number(value));
const isTaskPending = (value) => value === 0 || value === 1 || value === '0' || value === '1';

const getQueryParams = () => ({
    pageNum: Number(currentPage.value),
    pageSize: Number(pageSize.value),
    exportType: exportType.value,
    state: state.value
});

const getExportTaskList = async (polling = false) => {
    clearTimeout(pollingTimer);
    if (disposed) return;
    const version = ++requestVersion;
    // 轮询沿用已查询条件，避免未点击搜索的筛选值改变当前列表。
    if (!polling) appliedQueryParams = getQueryParams();
    loading.value = !polling;
    let shouldPoll = polling;
    try {
        const res = await queryExportTaskList({ ...appliedQueryParams });
        if (disposed || version !== requestVersion) return;
        if (res.data.code === 0) {
            tableData.value = res.data.data?.data || [];
            total.value = res.data.data?.total || 0;
            shouldPoll = true;
        } else if (!polling) {
            ElMessage.error(res.data.msg);
        }
    } catch (error) {
        if (!isRequestErrorHandled(error) && !disposed && version === requestVersion && !polling) {
            ElMessage.error('导出任务加载失败，请重试');
        }
    } finally {
        if (!disposed && version === requestVersion) {
            loading.value = false;
            if (shouldPoll && tableData.value.some((row) => isTaskPending(row.state))) {
                pollingTimer = setTimeout(() => getExportTaskList(true), 3000);
            }
        }
    }
};

const searchBtn = () => {
    currentPage.value = 1;
    getExportTaskList();
};

const resetBtn = () => {
    exportType.value = '';
    state.value = '';
    currentPage.value = 1;
    pageSize.value = 10;
    getExportTaskList();
};

const handleSizeChange = (value) => {
    pageSize.value = value;
    currentPage.value = 1;
    getExportTaskList();
};

const handleCurrentChange = (value) => {
    currentPage.value = value;
    getExportTaskList();
};

const downloadFile = (row) => {
    currentTime.value = Date.now();
    if (!canDownload(row)) return;
    // window.open(row.fileUrl, '_blank');
    window.location.href = row.fileUrl;
};

onMounted(() => {
    currentTime.value = Date.now();
    expirationTimer = setInterval(() => {
        currentTime.value = Date.now();
    }, 1000);
    getExportTaskList();
});

onUnmounted(() => {
    disposed = true;
    requestVersion++;
    clearTimeout(pollingTimer);
    clearInterval(expirationTimer);
});
</script>

<style lang="scss" scoped>
.partner {
    height: calc(100vh - 170px);
    width: 95%;
    padding: 20px;
    margin: 15px auto;
    overflow: auto;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: var(--el-box-shadow-light);
}

.header_btn {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
}

.common_ipt {
    width: 220px;
    margin: 0 10px 10px 0;
}

.force-style-input {
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
}

.summation {
    display: flex;
    justify-content: space-between;
}

.hint {
    font-size: 14px;
    color: #909399;
    margin-bottom: 15px;
}

.bulur {
    color: #409eff;
    border: none;
    --el-button-bg-color: none;
    --el-button-hover-bg-color: none;
    --el-button-hover-text-color: none;
}

.bulur:hover { color: #a0cfff; }

.cancel {
    margin-right: 5px;
    font-weight: 400;
}

.task-loading-icon {
    margin-right: 5px;
    vertical-align: middle;
}

.el-pagination { margin-top: 10px; }

::v-deep .el-table .el-table__cell {
    padding-top: 12px;
    padding-bottom: 12px;
}
</style>
